var map = {
	"./achievement/achievement.module": [
		"./src/app/achievement/achievement.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"achievement-achievement-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./busallocation/busallocation.module": [
		"./src/app/busallocation/busallocation.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"busallocation-busallocation-module"
	],
	"./classes/classes.module": [
		"./src/app/classes/classes.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"classes-classes-module"
	],
	"./dashboards/dashboard.module": [
		"./src/app/dashboards/dashboard.module.ts",
		"dashboards-dashboard-module"
	],
	"./events/events.module": [
		"./src/app/events/events.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"events-events-module"
	],
	"./exam/exam.module": [
		"./src/app/exam/exam.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"exam-exam-module"
	],
	"./fees/fees.module": [
		"./src/app/fees/fees.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"fees-fees-module"
	],
	"./gallery/gallery.module": [
		"./src/app/gallery/gallery.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"gallery-gallery-module"
	],
	"./imports/imports.module": [
		"./src/app/imports/imports.module.ts",
		"imports-imports-module"
	],
	"./notification/notification.module": [
		"./src/app/notification/notification.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"notification-notification-module"
	],
	"./promotestudent/promotestudent.module": [
		"./src/app/promotestudent/promotestudent.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"promotestudent-promotestudent-module"
	],
	"./school/school.module": [
		"./src/app/school/school.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"school-school-module"
	],
	"./sections/sections.module": [
		"./src/app/sections/sections.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"sections-sections-module"
	],
	"./staff/staff.module": [
		"./src/app/staff/staff.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"staff-staff-module"
	],
	"./staffrole/staffrole.module": [
		"./src/app/staffrole/staffrole.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"staffrole-staffrole-module"
	],
	"./student/student.module": [
		"./src/app/student/student.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"student-student-module"
	],
	"./subjects/subjects.module": [
		"./src/app/subjects/subjects.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"subjects-subjects-module"
	],
	"./teachers/teachers.module": [
		"./src/app/teachers/teachers.module.ts",
		"default~achievement-achievement-module~busallocation-busallocation-module~classes-classes-module~eve~76dde18f",
		"default~classes-classes-module~exam-exam-module~fees-fees-module~notification-notification-module~pr~5a9f3980",
		"teachers-teachers-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;